<template>
    <div>
        <div class="header">Настройки</div>

        <main-menu-button to="/token">
            Задать пароль доступа
        </main-menu-button>
        <main-menu-button to="/select_fridge" v-if="isTokenSet">
            Выбрать холодильник
        </main-menu-button>

        <template v-if="isTokenSet && isFridgeSet">
            <div class="header">Тесты</div>

            <main-menu-button to="/test_lock">
                Тестировать замок
            </main-menu-button>
            <main-menu-button to="/test_rfid">
                Тестировать RFID
            </main-menu-button>
            <main-menu-button to="/test_scales">
                Тестировать весы
            </main-menu-button>
            <main-menu-button to="/test_scales_shelf">
                Тестировать полочные весы
            </main-menu-button>
        </template>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import MainMenuButton from "../components/MainMenuButton";


    export default {
        name: "Home",
        components: {MainMenuButton},
        computed: {
            ...mapState('app', {
                token: 'token',
            }),
            ...mapGetters('app', {
                fridgeId: 'fridgeId',
            }),
            isFridgeSet() {
                return !!this.fridgeId;
            },
            isTokenSet() {
                return !!this.token && this.token.length > 0;
            },
        },
    }
</script>

<style scoped>
    .header {
        text-align: center;
        font-size: 1.6em;
    }
</style>
